import React, { useEffect } from 'react'
import { TransactionsSummary } from '../components/transactionsSummary/TransactionsSummary'
import { CurrentPositionParametersMobile } from '../components/parameters/CurrentPositionParameters'
import { setApplicationParameter } from '../store/actions/applicationParameters'
import * as con from "../GlobalConstants"

const tableColumns = [
    { [con.ID]: con.DATE },
    { [con.ID]: con.EXPOSURE_AMOUNT },
    { [con.ID]: con.COVERAGE_AMOUNT },
    { [con.ID]: con.COVERAGE_PERCENTAGE },
    { [con.ID]: con.RATE },
    { [con.ID]: con.VAR }
]

function MobileCurrentPositionPage() {

    useEffect(() => {
        setApplicationParameter(con.VISUALIZATION_PERIODICITY, con.PERIODICITY_MONTH)
        setApplicationParameter(con.ONLY_NON_ZERO_ROWS, true)
    }, [])

    return (
        <div style={{ minHeight: con.MOBILE_USABLE_SCREEN_SIZE + "vh" }}>
            
            {/* Selector del escenario */}
            <div style={{ marginTop: "20px" }}>
                <CurrentPositionParametersMobile />
            </div>

            {/* Tabla de TransactionsSummary */}
            <div style={{ paddingLeft: '15px', paddingRight: '15px', marginTop: "20px" }}>
                <TransactionsSummary selectedColumns={tableColumns} />
            </div>

        </div>
    )
}

export default MobileCurrentPositionPage
